import { useField } from 'components/common-form/hooks/useField';
import { useHighlightColor } from 'components/common-form/hooks/useHighlightColor';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { CompactPercentFieldAdjuster } from 'components/shared/CompactPercentField/CompactPercentFieldAdjuster';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { InfoTooltip } from 'components/shared/InfoTooltip/InfoTooltip';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const AdjustablePercentField: FC<ProductNodeBuilderProps> = ({ node: { id }, workspaceType, tabIndex }) => {
  const { metadata, data, setData } = useField<'AdjustablePercentField'>(id);
  const patchedFieldClassName = usePatchedFieldHighlight(id);

  const step = 0.1;

  const highlightColor = useHighlightColor();

  const tooltipKey = metadata?.hasTooltip ? `form.${metadata?.translationKey}.tooltip` : undefined;

  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={`form.${metadata?.translationKey}` as any}
      workspaceType={workspaceType}
      minWidth={metadata?.minWidth}
      maxWidth={metadata?.maxWidth}
      tooltipLocation={metadata?.tooltipLocation}
      className={patchedFieldClassName}
    >
      {tooltipKey !== undefined && <InfoTooltip id={`tooltip-${id}`} tooltipKey={tooltipKey as any} />}
      <div className="form-group mb-0">
        <CompactPercentFieldAdjuster
          id={id}
          onValueChange={setData}
          step={step}
          value={data !== null ? data : undefined}
          digits={metadata?.nbDecimals}
          alignRight={metadata?.textAlign === 'Right'}
          isHighlighted={metadata?.isHighlighted ? highlightColor : undefined}
          tabIndex={tabIndex}
        />
      </div>
    </BlockOrientationFormGroup>
  );
};

AdjustablePercentField.displayName = 'AdjustablePercentField';
